import { api } from "@/lib/api";

const key = (uid) => `bqns_seen_badges_${uid || "anon"}`;

export function getSeenBadges(userId) {
    try {
        const raw = localStorage.getItem(key(userId));
        return raw ? JSON.parse(raw) : [];
    } catch { return []; }
}

export function markBadgesSeen(userId, badgeIds) {
    const set = new Set([...getSeenBadges(userId), ...badgeIds]);
    try { localStorage.setItem(key(userId), JSON.stringify([...set])); } catch {}
}

/** Fetch current badges, return only IDs the user has NOT seen yet. */
export async function fetchNewBadges(userId) {
    try {
        const { data } = await api.get("/student/badges");
        const current = data?.badges || [];
        const seen = new Set(getSeenBadges(userId));
        // First-time users: seed as seen without celebration (avoid spam on first login for pre-existing badges? no, we want them to see)
        // Instead: on very first visit, seed silently to avoid overwhelming with all-at-once celebrations.
        if (seen.size === 0 && current.length > 0 && !localStorage.getItem(`${key(userId)}_init`)) {
            markBadgesSeen(userId, current);
            try { localStorage.setItem(`${key(userId)}_init`, "1"); } catch {}
            return [];
        }
        return current.filter((b) => !seen.has(b));
    } catch { return []; }
}
